import { serviceService } from '../../helpers/services/service.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper, ddlHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const SERVICE_MODULE = 'service';

// define action 
export const GET_ALL_SERVICES = 'getAllServices';
export const GET_SERVICE = 'getService';
export const UPDATE_SERVICE = 'updateService';
export const CREATE_SERVICE = 'createService';
export const UPDATE_SERVICE_STATUS = 'updateServiceStatus';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_SERVICES_REQUEST = "getAllServices";
const GET_SERVICE_REQUEST = "getService";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    [GET_ALL_SERVICES]({ commit }, { filter }) {
        serviceService
            .getAllServices(filter)
            .then(
                (result) => {
                    commit(GET_ALL_SERVICES_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    async [GET_SERVICE]({ commit }, { id }) {
       await serviceService
            .getService(id)
            .then(
                (result) => {
                    commit(GET_SERVICE_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_SERVICE]({ commit }, { data }) {
        commit(REQUEST)
        serviceService
            .updateService(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.service')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_SERVICE]({ commit }, { data }) {
        commit(REQUEST)
        serviceService
            .createService(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t("message.createXSuccess", [i18n.t('module.service')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_SERVICE_STATUS]({ dispatch }, { filter, data }) {
        serviceService
            .updateServiceStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_SERVICES, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    }

};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "Service-listing" });
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_SERVICES_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                name: o.name, // not array
                localeName: o.locale_name,
                image: o.image,
                description: o.description,
                afterServiceDescription: o.after_service_description,
                status: o.status,
                priceTypeID: o.price_type_id,
                price: o.price,
                isRebookNeeded: o.is_rebook_needed,
                permissions: o.permissions,
                rebookDayAfterService: o.rebook_day_after_service,
                durationMinutes: o.duration_minutes,
                package: o.package,
                serviceType: o.service_type,
                menu: o.menu,
                createdAt: filtersHelper.getDateFormat(o.created_at),
                createdBy: o.created_by,
                updatedBy: o.updated_by,
                updatedAt: filtersHelper.getDateFormat(o.updated_at)
            }
        })
    },
    [GET_SERVICE_REQUEST](state, data) {
        let o = data.data

        const languages = ddlHelper.getLanguages();

        var names = null;

        if (o.locale_name != null) {
            names = [];
            Object.keys(o.locale_name.name).forEach(key => {
                names.push({ language: languages.find(lang => lang.code === key), name: o.locale_name.name[key] });
            });
        }
        else {
            names = []
        }

        state.details = {
            uuid: o.uuid,
            name: o.name, // not array
            localeName: o.locale_name,
            names: names,
            image: o.image,
            description: o.description,
            afterServiceDescription: o.after_service_description,
            status: o.status,
            price: o.price,
            priceTypeID: o.price_type_id,
            isRebookNeeded: o.is_rebook_needed,
            permissions: o.permissions,
            rebookDayAfterService: o.rebook_day_after_service,
            durationMinutes: o.duration_minutes,
            package: o.package,
            serviceType: o.service_type,
            menu: o.menu,
            menuID: o.menu != null ? {
                value: o.menu.uuid,
                text: o.menu.name
            } : '',
            serviceTypeID: o.service_type != null ? {
                value: o.service_type.uuid,
                text: o.service_type.name
            } : '',
            createdAt: filtersHelper.getDateFormat(o.created_at),
            updatedBy: o.updated_by,
            createdBy: o.created_by,
            updatedAt: filtersHelper.getDateFormat(o.updated_at)
        }
    }
}


